/* =========================================
   SM-speeltjes – Judge.me live vertalingen
   Veilige rollbackversie: alleen Engels
========================================= */

(function () {
  "use strict";

  const translations = {
    en: {
      /* Gewone reviewweergave */
      "Klantbeoordelingen": "Customer reviews",
      "Schrijf een beoordeling": "Write a review",
      "Bekijk alle beoordelingen": "View all reviews",
      "Nog geen beoordelingen": "No reviews yet",
      "Geen items gevonden": "No items found",
      "Wees de eerste om een beoordeling te schrijven":
        "Be the first to write a review",

      /* Eerste stap */
      "Hoe zou je dit product beoordelen?":
        "How would you rate this product?",

      "We zouden het op prijs stellen als je iets over je ervaring zou willen delen.":
        "We'd appreciate it if you shared your experience.",

      "Slecht": "Poor",
      "slecht": "Poor",
      "Goed": "Good",
      "goed": "Good",

      /* Beoordeling schrijven */
      "Beoordeling inhoud": "Review content",
      "Begin hier met schrijven...": "Start writing here...",
      "Titel beoordeling": "Review title",
      "Geef je beoordeling een titel": "Give your review a title",

      "Terug": "Back",
      "Volgende": "Next",

      /* Voorwaarden onder het formulier */
      "We nemen alleen contact met u op over uw beoordeling indien nodig. Door uw beoordeling in te dienen, gaat u akkoord met onze algemene voorwaarden en privacybeleid.":
        "We will only contact you about your review if necessary. By submitting your review, you agree to our Terms & Conditions and Privacy Policy.",

      "We nemen alleen contact met u op over uw beoordeling indien nodig. Door uw beoordeling in te dienen, gaat u akkoord met onze":
        "We will only contact you about your review if necessary. By submitting your review, you agree to our",

      "We nemen alleen contact met u op over uw beoordeling indien nodig.":
        "We will only contact you about your review if necessary.",

      "Door uw beoordeling in te dienen, gaat u akkoord met onze":
        "By submitting your review, you agree to our",

      "algemene voorwaarden": "Terms & Conditions",
      "privacybeleid": "Privacy Policy",
      "privacybeleid.": "Privacy Policy.",

      /* Persoonlijke gegevens */
      "Over jou": "About you",
      "Vertel ons meer over jezelf.": "Tell us more about yourself.",

      "E-mailadres (Verplicht)": "Email address (Required)",
      "Je e-mailadres": "Your email address",
      "We respecteren uw privacy.": "We respect your privacy.",

      "Weergavenaam (Verplicht)": "Display name (Required)",
      "Weergavenaam": "Display name",
      "Anonieme beoordeling": "Anonymous review",

      /* Foto of video */
      "Deel een foto of video": "Share a photo or video",

      "Upload een foto of video om uw recensie te ondersteunen.":
        "Upload a photo or video to support your review.",

      "Klik om te uploaden": "Click to upload",
      "of sleep en zet neer": "or drag and drop",

      "YouTube URL": "YouTube URL",
      "Youtube URL": "YouTube URL",

      "Plak hier uw Youtube URL": "Paste your YouTube URL here",
      "Plak hier uw YouTube URL": "Paste your YouTube URL here",

      /* Bedankpagina */
      "Bedankt voor je beoordeling!":
        "Thank you for your review!",

      "We verwerken deze en hij zal binnenkort in de winkel verschijnen.":
        "We are processing it and it will appear in the store soon.",

      "Bevestig je e-mail door op de link te klikken die we je net hebben gestuurd. Dit helpt ons om beoordelingen authentiek te houden.":
        "Please confirm your email by clicking the link we just sent you. This helps us keep reviews authentic.",

      "Wilt u uw winkelervaring met ons delen?":
        "Would you like to share your shopping experience with us?",

      "Wil je je ervaring met ons delen?":
        "Would you like to share your experience with us?",

      /* Feedbacktekst */
      "We waarderen je feedback en gebruiken het om te verbeteren. Deel alstublieft enige gedachten of suggesties die je hebt.":
        "We value your feedback and use it to improve. Please share any thoughts or suggestions you may have.",

      "We waarden je feedback en gebruiken het om te verbeteren. Deel alstublieft enige gedachten of suggesties die je hebt.":
        "We value your feedback and use it to improve. Please share any thoughts or suggestions you may have.",

      "We waarderen je feedback en gebruiken het om te verbeteren.":
        "We value your feedback and use it to improve.",

      "We waarden je feedback en gebruiken het om te verbeteren.":
        "We value your feedback and use it to improve.",

      "Deel alstublieft enige gedachten of suggesties die je hebt.":
        "Please share any thoughts or suggestions you may have.",

      "Sluiten": "Close"
    }
  };

  function getLanguage() {
    const host = window.location.hostname.toLowerCase();

    if (host.startsWith("en.")) return "en";
    if (host.startsWith("de.")) return "de";
    if (host.startsWith("fr.")) return "fr";
    if (host.startsWith("es.")) return "es";
    if (host.startsWith("it.")) return "it";
    if (host.startsWith("pt.")) return "pt";
    if (host.startsWith("sv.")) return "sv";
    if (host.startsWith("no.")) return "no";
    if (host.startsWith("da.")) return "da";

    return "nl";
  }

  function normalizeText(value) {
    return String(value || "")
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function findTranslation(value, dictionary) {
    const normalized = normalizeText(value);

    if (!normalized) return null;

    for (const sourceText in dictionary) {
      if (normalizeText(sourceText) === normalized) {
        return dictionary[sourceText];
      }
    }

    return null;
  }

  function translateTextNode(node, dictionary) {
    const original = node.nodeValue;
    const translated = findTranslation(original, dictionary);

    if (!translated) return;

    const leadingSpace = original.match(/^\s*/)?.[0] || "";
    const trailingSpace = original.match(/\s*$/)?.[0] || "";

    node.nodeValue = leadingSpace + translated + trailingSpace;
  }

  function translateAttributes(element, dictionary) {
    ["placeholder", "aria-label", "title"].forEach(function (attribute) {
      if (!element.hasAttribute(attribute)) return;

      const currentValue = element.getAttribute(attribute);
      const translated = findTranslation(currentValue, dictionary);

      if (translated) {
        element.setAttribute(attribute, translated);
      }
    });
  }

  function translateElement(element, dictionary) {
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return;

    translateAttributes(element, dictionary);

    Array.from(element.childNodes).forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        translateTextNode(node, dictionary);
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        translateElement(node, dictionary);
      }
    });
  }

  function getJudgeMeRoots() {
    const selectors = [
      ".jdgm-widget",
      ".jdgm-review-widget",
      ".jdgm-all-reviews-widget",
      ".jdgm-write-review-modal",
      ".jdgm-review-widget-modal",
      "[class*='jdgm-']"
    ];

    return Array.from(
      new Set(document.querySelectorAll(selectors.join(",")))
    );
  }

  let observer = null;
  let translationTimer = null;

  function observePage() {
    if (!observer || !document.body) return;

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: [
        "placeholder",
        "aria-label",
        "title"
      ]
    });
  }

  function translateJudgeMe() {
    const language = getLanguage();
    const dictionary = translations[language];

    if (!dictionary) return;

    if (observer) {
      observer.disconnect();
    }

    getJudgeMeRoots().forEach(function (root) {
      translateElement(root, dictionary);
    });

    observePage();
  }

  function scheduleTranslation() {
    window.clearTimeout(translationTimer);

    translationTimer = window.setTimeout(function () {
      translateJudgeMe();
    }, 100);
  }

  function start() {
    observer = new MutationObserver(function () {
      scheduleTranslation();
    });

    translateJudgeMe();
    observePage();

    document.addEventListener("click", function () {
      window.setTimeout(translateJudgeMe, 150);
      window.setTimeout(translateJudgeMe, 400);
    });

    window.translatePage = translateJudgeMe;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
